export function formatFeedPrice({
  price,
  currency,
  locale,
}: {
  price: number;
  currency: string | null | undefined;
  locale: string;
}) {
  const code = currency?.trim().toUpperCase();

  if (!code) {
    return new Intl.NumberFormat(locale).format(price);
  }

  try {
    return new Intl.NumberFormat(locale, {
      style: 'currency',
      currency: code,
    }).format(price);
  } catch {
    return `${new Intl.NumberFormat(locale).format(price)} ${code}`;
  }
}
